import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../../services/auth/authService';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Prevents double-execution under React 18 StrictMode.
  const hasChecked = useRef(false);

  useEffect(() => {
    if (hasChecked.current) return;
    hasChecked.current = true;

    const checkAuth = async () => {
      try {
        setIsChecking(true);

        // After a cross-tab broadcast logout, other tabs set this marker so
        // Login waits before calling initiateLogin(). Without the delay the
        // SSO session may not be fully terminated yet, causing a silent
        // SSO re-authentication that leaves the user appearing still signed in.
        const isForcedLogout = sessionStorage.getItem('auth_forced_logout') === '1';
        if (isForcedLogout) {
          sessionStorage.removeItem('auth_forced_logout');
          await new Promise<void>((resolve) => setTimeout(resolve, 2000));
          authService.initiateLogin();
          return;
        }

        const isAuthenticated = await authService.checkAndRefreshAuth();

        if (isAuthenticated) {
          navigate('/requestor');
        } else {
          setIsChecking(false);
          authService.initiateLogin();
        }
      } catch (err) {
        console.error('Authentication check failed:', err);
        setError('Authentication failed. Please try again.');
        setIsChecking(false);
      }
    };

    checkAuth();
  }, [navigate]);

  if (isChecking) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Checking authentication status...</h2>
        <p>Please wait while we verify your session.</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
        <h2>Error</h2>
        <p>{error}</p>
        <button type="button" onClick={() => window.location.reload()}>
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>Redirecting to login...</h2>
      <p>Please wait while we redirect you to the authentication page.</p>
    </div>
  );
};

export default Login;
